module.exports = __webpack_public_path__ + "media/assets/images/blog/app_map-small-e01b42debd77bbb044d54f77d5b92744.png";